module.exports = __webpack_public_path__ + "static/media/MenuIcon_AERO.04a61cbd.svg";